export default {"src":"/_next/static/media/heart.255858aa.svg","height":38,"width":39};